export const teamConsts = {
  GET_MEMBERS_LIST: "GET_MEMBERS_LIST",
  CREATE_TEAM_MEMBER: "CREATE_TEAM_MEMBER",
  UPDATE_TEAM_MEMBER_POSITION: "UPDATE_TEAM_MEMBER_POSITION",
  GET_TEAM_MEMBER_BY_ID: "GET_TEAM_MEMBER_BY_ID",
  UPDATE_TEAM_MEMBER_BY_ID: "UPDATE_TEAM_MEMBER_BY_ID",
  DELETE_TEAM_MEMBER_BY_ID: "DELETE_TEAM_MEMBER_BY_ID",
};